import { FC } from 'react';
import { CategoryFilterProps, Styled } from './';
import { useI18n } from 'contexts/i18n';
import { Checkbox } from 'components/core/Checkbox';

const CategoryFilter: FC<CategoryFilterProps> = ({
  categoryFilters,
  onChange,
  appliedCategoryFilters,
}) => {
  const i18n = useI18n();
  return (
    <>
      {categoryFilters && categoryFilters.length > 1 && (
        <>
          <Styled.FilterHeading>{i18n['Filters']}</Styled.FilterHeading>
          <Styled.FilterContainer>
            <Styled.FilterTitle>{i18n['Categories']}</Styled.FilterTitle>
            <Styled.Line />
            <Styled.FilterBody>
              {categoryFilters.map(category => {
                return (
                  <Styled.SubCategoryContainer key={category.categoryId}>
                    <Styled.SubCategoryItem>
                      <Checkbox
                        label={category.categoryName}
                        checked={appliedCategoryFilters.includes(
                          category.categorySlug
                        )}
                        value={category.categorySlug}
                        onChange={onChange}
                      />
                    </Styled.SubCategoryItem>
                  </Styled.SubCategoryContainer>
                );
              })}
            </Styled.FilterBody>
          </Styled.FilterContainer>
        </>
      )}
    </>
  );
};

export default CategoryFilter;
